@if (!isSidebarLoading()) {
  <div class="h-full flex flex-col">
    <app-sidebar-header
      [showBackButton]="!isEdit || (currentPage$ | async) !== COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE"
      (backButtonClicked)="goBack()"
    >
      <div smallTitle>{{ isEdit ? 'Edit Invoice' : 'Add Invoice' }}</div>
      @if ((currentPage$ | async) === 1) {
        <div mainTitle>General Information</div>
      }
    </app-sidebar-header>
    <ng-scrollbar
      [ngClass]="{ 'first-page': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
      class="std-scrollbar wider-track"
      appearance="compact"
      orientation="vertical"
    >
      <div
        [ngClass]="{ 'mt-5': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
        class="scrollable-content mb-5"
      >
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
          <form class="flex flex-col flex-1 horizontal-spacing" #firstPageForm="ngForm" role="form" [@fadeInGeneral]>
            <div class="flex-1 flex flex-col">
              <app-upload-commitments-sidebar
                [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.INVOICES"
              ></app-upload-commitments-sidebar>
              <div class="two-input-row">
                <app-floating-input
                  [(ngModel)]="model.service_provider.name"
                  [required]="true"
                  [readonly]="true"
                  [disabled]="isEdit"
                  (click)="isDropdownShown.service_provider = true"
                  #optionsTrigger="cdkOverlayOrigin"
                  #serviceProviderModel="ngModel"
                  cdkOverlayOrigin
                  class="flex-1 cursor-pointer"
                  wrapperClass="cursor-pointer"
                  inputClass="cursor-pointer"
                  id="serviceProviderUserId"
                  name="serviceProviderUserId"
                  label="Company Name"
                  placeholder="Company Name"
                  [iconClass]="isDropdownShown.service_provider ? 'dropdown-icon opened' : 'dropdown-icon closed'"
                >
                </app-floating-input>
                <app-overlay-general
                  [(show)]="isDropdownShown.service_provider"
                  [trigger]="optionsTrigger"
                  [overlayPositions]="dropdownOverlayPositions"
                >
                  <app-company-dropdown
                    (optionSelected)="selectedCompany($event, serviceProviderModel)"
                    [hideAddCompany]="true"
                  ></app-company-dropdown>
                </app-overlay-general>
                <app-dropdown
                  [required]="true"
                  name="contract_id"
                  [(ngModel)]="model.contract_id"
                  [options]="filteredContractsByCompany"
                  [disabled]="isEdit"
                  optionLabel="title"
                  optionValue="id"
                  (ngModelChange)="updateInvoice(); loadContractSummaryDetails()"
                  label="Contract Title"
                >
                </app-dropdown>
              </div>
              <div class="two-input-row">
                <app-floating-input
                  [required]="true"
                  name="title"
                  [(ngModel)]="model.title"
                  (ngModelChange)="updateInvoice()"
                  label="Invoice Title"
                >
                </app-floating-input>
                <app-dropdown
                  [required]="true"
                  placeholder="Invoice Status"
                  label="Invoice Status"
                  name="paid_status"
                  [(ngModel)]="model.paid_status"
                  [options]="paidStatuses"
                  (ngModelChange)="updateInvoice()"
                >
                  <ng-template let-status #optionContent>
                    @if (status) {
                      <div [ngClass]="status.value ? 'text-navy-900' : 'text-navy-600'" class="capitalize text-medium">
                        {{ status.text }}
                      </div>
                    } @else {
                      <div>NO STATUS</div>
                    }
                  </ng-template>
                  <ng-template let-status #selectedContent>
                    @if (status) {
                      <div [ngClass]="status.value ? 'text-navy-900' : 'text-navy-600'" class="capitalize text-medium">
                        {{ status.text }}
                      </div>
                    }
                  </ng-template>
                </app-dropdown>
              </div>
              <div class="two-input-row">
                <app-input-calendar
                  #added_at_calendar
                  [required]="true"
                  [date]="model.added_at"
                  [minStartDate]="(selectedContract$ | async)?.contract?.added_at ?? projectData?.start_date"
                  (dateChanged)="updateAddedAtDate($event)"
                  placeholder="Invoice Date"
                  name="added_at"
                  [ngClass]="{
                    'col-span-2': !model.paid_status,
                  }"
                  [showIcon]="true"
                ></app-input-calendar>
                @if (!!model.paid_status) {
                  <app-input-calendar
                    #paid_calendar
                    [required]="true"
                    [date]="model.paid_date"
                    [minStartDate]="model?.added_at ?? projectData?.start_date"
                    (dateChanged)="updatePaidDate($event)"
                    placeholder="Paid Date"
                    name="paid_date"
                    [showIcon]="true"
                  ></app-input-calendar>
                }
              </div>
              <app-floating-textarea
                [(ngModel)]="model.description"
                (ngModelChange)="updateInvoice()"
                [rows]="5"
                [cols]="30"
                label="Invoice Description"
                name="description"
              >
              </app-floating-textarea>
            </div>
          </form>
        } @else {
          <div [@fadeInGeneral]>
            <app-commitment-entry-text text="Invoice Entry"></app-commitment-entry-text>
            <div class="horizontal-spacing">
              <app-floating-input
                #optionsTrigger="cdkOverlayOrigin"
                (click)="isDropdownShown.budget_tag = true"
                cdkOverlayOrigin
                id="budget_tag"
                name="budget_tag"
                [(ngModel)]="model.budget_tag.name"
                placeholder="Budget Tag"
                label="Budget Tag"
                readonly
                class="cursor-pointer"
                [iconClass]="isDropdownShown.budget_tag ? 'dropdown-icon opened' : 'dropdown-icon closed'"
              ></app-floating-input>
              <app-overlay-general
                [(show)]="isDropdownShown.budget_tag"
                [trigger]="optionsTrigger"
                [overlayPositions]="dropdownOverlayPositions"
              >
                <app-budget-tag-templates-dropdown
                  [budgetTemplateTags]="budgetTagTemplates"
                  [hasTemplate]="!!model.budget_tag.id"
                  [showAllTags]="true"
                  (optionSelected)="selectedBudgetTag($event)"
                  (selectAllTagsLocalOption)="selectedAllBudgetTags()"
                  (unlinkTemplate)="unlinkTemplate()"
                ></app-budget-tag-templates-dropdown>
              </app-overlay-general>
              @for (cost of costs; track $index; let index = $index) {
                <app-cost-description
                  #costDescription
                  [commitmentType]="commitmentType"
                  [spendEntryIndex]="0"
                  [costIndex]="index"
                  [model]="cost"
                  [totalCostCount]="costs.length"
                  [disableAddDescription]="!canAddInvoiceCosts()"
                >
                </app-cost-description>
              }
            </div>
          </div>
        }
      </div>
    </ng-scrollbar>
    <div
      class="bottom-container"
      [ngClass]="{ bordered: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE }"
    >
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE) {
        <span class="text-navy-700 text-base font-bold flex flex-1">
          <span class="flex-1">Total Invoice</span>
          <span class="flex-1 justify-center flex" [ngClass]="{ negative: (totalInvoiceCost$ | async) < 0 }">
            @if ((totalInvoiceCost$ | async) !== 0) {
              <span>{{ totalInvoiceCost$ | async | money: 'positiveComa' }}</span>
            }
            @if ((totalInvoiceCost$ | async) === 0) {
              <span>$ {{ totalInvoiceCost$ | async | number }}</span>
            }
          </span>
        </span>
      }
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
        <app-simple-button
          [wrapperClass]="{
            rounded: true,
          }"
          (click)="incrementPage()"
          [disabled]="isLoading"
        >
          @if (!isLoading) {
            <span>Next</span>
          }
          @if (isLoading) {
            <span class="icon-refresh animate-spin"></span>
          }
        </app-simple-button>
      } @else {
        <app-simple-button
          (click)="save()"
          [disabled]="isLoading"
          [wrapperClass]="{
            'bg-yellow-500 rounded': true,
          }"
        >
          @if (!isLoading) {
            <span>Submit</span>
          }
          @if (isLoading) {
            <span class="icon-refresh animate-spin"></span>
          }
        </app-simple-button>
      }
    </div>
  </div>
} @else {
  <div class="flex w-full h-full items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
